import React, { useEffect, useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import NoData from "../../utils/DataNotFound";
import { ToastContainer } from "react-toastify";
import profile from "../../assets/img/profile.jpg";

export default function AllUsers() {
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 10;

  const [selectedUser, setSelectedUser] = useState(null);
  const [filters, setFilters] = useState({
    keyword: "",
    fromDate: "",
    toDate: "",
    status: "",
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const U = (v) => v ?? "-";

  useEffect(() => {
    setPageNo(1);
  }, [
    filters.keyword,
    filters.status,
    filters.sortBy,
    filters.sortOrder,
  ]);

  useEffect(() => {
    fetchUsers();
  }, [pageNo, filters]);


  const fetchUsers = async () => {
    try {
      const response = await makeRequestAuth("post", "/admin/getUserList", {
        keyWord: filters.keyword,
        fromDate: filters.fromDate,
        toDate: filters.toDate,
        status: filters.status,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        pageNo,
        size: pageSize,
      });

      setUsers(response.data.list || []);
      setTotalUsers(response.data.total || 0);
    } catch (error) {
      console.log("Error Fetching Users:", error);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const response = await makeRequestAuth(
        "post",
        "/admin/usetStatustoggel",
        {
          id
        }
      );

      const resData = response?.data;

      if (resData?.error) {
        showErrorToast(resData?.error || "Something went wrong");
        return;
      }

      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user._id === id
            ? { ...user, isDisable: !user.isDisable }
            : user
        )
      );
      showSuccessToast("Property status updated successfully!");

    } catch (error) {
      console.error("Error updating property status:", error);

      const errorMessage =
        error?.response?.data?.message.status ||
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update property status. Please try again later.";

      showErrorToast(errorMessage);
    }
  };

  return (
    <div>
      <ToastContainer />
      <h2 className="text-xl font-bold mb-4">User Mennagement</h2>

      {/* FILTERS */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">

        <input
          type="text"
          placeholder="Search..."
          className={`border p-2 rounded w-full ${filters.keyword ? "border-[#24ADD7] shadow-sm" : ""
            }`}
          value={filters.keyword}
          onChange={(e) =>
            setFilters({ ...filters, keyword: e.target.value })
          }
        />

        <select
          className={`border p-2 rounded w-full ${filters.status ? "border-[#24ADD7] shadow-sm" : ""
            }`}
          value={filters.status}
          onChange={(e) =>
            setFilters({ ...filters, status: e.target.value })
          }
        >
          <option value="">All Status</option>
          <option value="false">Active</option>
          <option value="true">Inactive</option>
        </select>
      </div>

      {/* SORTING */}
      <div className="flex items-center gap-4 mb-5">
        <select
          className={`border p-2 rounded ${filters.sortBy !== "" ? "border-[#24ADD7]" : ""
            }`}
          value={filters.sortBy}
          onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}
        >
          <option value="createdAt">Created At</option>
          <option value="name">Name</option>
          <option value="email">Email</option>
        </select>

        <select
          className={`border p-2 rounded ${filters.sortOrder !== "" ? "border-[#24ADD7]" : ""
            }`}
          value={filters.sortOrder}
          onChange={(e) =>
            setFilters({ ...filters, sortOrder: e.target.value })
          }
        >
          <option value="desc">Descending</option>
          <option value="asc">Ascending</option>
        </select>

      </div>

      {/* TABLE */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200 text-left">
              <th className="p-3">SR No.</th>
              <th className="p-3">Image</th>
              <th className="p-3">Name</th>
              <th className="p-3">Email</th>
              <th className="p-3">Mobile</th>
              <th className="p-3">Status</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="7">
                  <NoData title="User Not Found!" />
                </td>
              </tr>
            ) : (
              users.map((user, index) => (
                <React.Fragment key={user._id}>
                  <tr className="border-b">
                    <td className="p-3">{U(index + 1)}</td>

                                       <td className="p-3">
                      <img
                        src={user.image || profile}
                        alt="user"
                        onClick={() => setSelectedUser(user)}
                        title="Click to view plan"
                        className="h-12 w-12 rounded-full object-cover border cursor-pointer hover:ring-2 hover:ring-blue-500 transition-all"
                      />
                    </td>


                    <td className="p-3">{U(user.name)}</td>
                    <td className="p-3">{U(user.email)}</td>
                                        <td className="p-3">{U(user.phone)}</td>

                    {/* === YAHAN SE NAYA CODE PASTE KAREIN === */}
                    {/* <td className="p-3 text-xs">
                      {user.subscription ? (
                        <div className="bg-blue-50 p-2 rounded-md border border-blue-100 min-w-[220px]">
                          <p className="font-bold text-blue-800 mb-1">
                            {user.subscription.planId?.name || "Active Plan"}
                          </p>
                          <p className="text-gray-600 mb-2">
                            End Date: {new Date(user.subscription.endDate).toLocaleDateString()}
                          </p>
                          {user.subscription.usageTracking && user.subscription.usageTracking.map((limit, i) => (
                            <div key={i} className="flex justify-between border-t border-blue-100 pt-1 mt-1">
                              <span className="text-gray-700 w-32 truncate" title={limit.pointName}>{limit.pointName}</span>
                              <span className="font-black text-blue-600 ml-2">
                                Used: {limit.usedCount}/{limit.totalLimit}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="text-gray-400 font-medium">No Active Plan</span>
                      )}
                    </td>
                    === YAHAN TAK === */}

                    <td className="p-3">

                      <span
                        className={`px-3 py-1 rounded text-white ${user.isDisable === false
                          ? "bg-green-600"
                          : "bg-red-600"
                          }`}
                      >
                        {user.isDisable === false ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td className="p-3">
                      <select
                        value={String(user.isDisable)}
                        onChange={(e) =>
                          handleStatusChange(user._id, e.target.value)
                        }
                        className={`mt-2 px-4 py-1 rounded-md border text-sm font-semibold focus:outline-none ${user.isDisable === false
                          ? "bg-green-50 border-green-500 text-green-600"
                          : "bg-red-50 border-red-500 text-red-600"
                          }`}
                      >
                        <option value="false">Active</option>
                        <option value="true">Inactive</option>
                     </select>

                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-end mt-4 items-center gap-4">
        <button
          disabled={pageNo <= 1}
          onClick={() => setPageNo(pageNo - 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Prev
        </button>

        <span>
          Page {pageNo} / {Math.ceil(totalUsers / pageSize)}
        </span>

        <button
          disabled={pageNo >= totalUsers / pageSize}
          onClick={() => setPageNo(pageNo + 1)}
          className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
                {/* PREMIUM USER PROFILE MODAL */}
      {selectedUser && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 transition-all duration-300">
          <div className="bg-white rounded-[24px] shadow-2xl max-w-md w-full relative max-h-[95vh] overflow-y-auto flex flex-col transform transition-all">
            
            {/* Gradient Header */}
            <div className="h-32 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 relative shrink-0">
              <button 
                onClick={() => setSelectedUser(null)}
                className="absolute top-4 right-4 bg-white/20 hover:bg-white/40 text-white h-8 w-8 rounded-full flex items-center justify-center font-bold text-lg transition-all"
              >
                ✕
              </button>
            </div>
            
            {/* Scrollable Body */}
            <div className="px-6 pb-6 relative flex-1">
              
              {/* Profile Image (Overlapping) */}
              <div className="flex justify-between items-end -mt-12 mb-4">
                <img 
                  src={selectedUser.image || profile} 
                  alt="user" 
                  className="h-24 w-24 rounded-full object-cover border-4 border-white shadow-md bg-white" 
                />
                <span className={`px-3 py-1 rounded-full text-[11px] font-black tracking-wider shadow-sm mb-2 ${selectedUser.isDisable === false ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                  {selectedUser.isDisable === false ? "● ACTIVE" : "● INACTIVE"}
                </span>
              </div>

              {/* User Name & Basic Info */}
              <div className="mb-6">
                <h3 className="text-2xl font-black text-gray-900 mb-1">{selectedUser.name || "Unknown User"}</h3>
                <p className="text-gray-500 font-medium text-sm flex items-center gap-2">
                  <span>📞 {selectedUser.phone || "-"}</span>
                  <span className="text-gray-300">|</span>
                  <span className="truncate" title={selectedUser.email}>✉️ {selectedUser.email || "-"}</span>
                </p>
              </div>

              {/* Address Details (Clean Card) */}
              <div className="bg-gray-50/80 rounded-xl p-4 mb-6 border border-gray-100">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Location & Joining</p>
                <div className="space-y-3 text-sm">
                  <div className="flex items-start gap-3">
                    <span className="text-lg">📍</span>
                    <p className="font-semibold text-gray-700 mt-0.5 leading-snug">
                      {[selectedUser.address, selectedUser.city, selectedUser.state, selectedUser.pincode].filter(Boolean).join(", ") || "No address provided"}
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-lg">📅</span>
                    <p className="font-semibold text-gray-700">
                      Joined: <span className="text-gray-900 font-black">{selectedUser.createdAt ? new Date(selectedUser.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }) : "-"}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Plan Details Section (Premium Dark Card) */}
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Current Subscription</p>
                {selectedUser.subscription ? (
                  <div className="bg-gradient-to-br from-[#131224] to-[#252345] rounded-2xl p-5 shadow-lg text-white relative overflow-hidden">
                    {/* Background Glow */}
                    <div className="absolute -top-10 -right-10 w-32 h-32 bg-white opacity-5 rounded-full blur-2xl"></div>
                    
                    <div className="flex justify-between items-start mb-5 relative z-10">
                      <div>
                        <h4 className="font-black text-2xl tracking-tight text-white mb-1">
                          {selectedUser.subscription.planId?.name || "Premium Plan"}
                        </h4>
                        <p className="text-blue-200 text-[10px] font-bold uppercase tracking-widest flex items-center gap-1">
                          ⏳ Expires: {new Date(selectedUser.subscription.endDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                        </p>
                      </div>
                      <div className="h-10 w-10 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm shadow-inner text-xl">
                        👑
                      </div>
                    </div>
                    
                    <div className="space-y-2 relative z-10">
                      {selectedUser.subscription.usageTracking && selectedUser.subscription.usageTracking.map((limit, i) => (
                        <div key={i} className="flex justify-between items-center bg-white/10 hover:bg-white/20 transition-colors p-2.5 rounded-xl border border-white/5 backdrop-blur-sm">
                          <span className="font-semibold text-sm text-gray-100 w-44 truncate" title={limit.pointName}>
                            {limit.pointName}
                          </span>
                          <div className="flex items-center gap-2">
                            <span className="text-[9px] uppercase text-gray-300 font-bold tracking-wider">Used</span>
                            <span className="font-black text-white text-xs bg-black/40 px-2.5 py-1 rounded-lg">
                              {limit.usedCount} <span className="text-gray-400">/ {limit.totalLimit}</span>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="bg-gray-50 border-2 border-dashed border-gray-200 rounded-2xl p-6 text-center flex flex-col items-center justify-center">
                    <span className="text-3xl mb-2">🤷‍♂️</span>
                    <h4 className="text-gray-700 font-bold text-base mb-1">No Active Plan</h4>
                    <p className="text-gray-400 text-xs font-semibold">This user hasn't subscribed to any plan yet.</p>
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      )}

            {/* PREMIUM USER PROFILE MODAL */}
      {selectedUser && (
<div className="bg-white rounded-[24px] shadow-2xl max-w-md w-full relative max-h-[95vh] overflow-y-auto flex flex-col transform transition-all">
          <div className="bg-white rounded-[24px] shadow-2xl max-w-md w-full relative max-h-[95vh] overflow-hidden flex flex-col transform transition-all">
            
            {/* Gradient Header */}
            <div className="h-32 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 relative">
              <button 
                onClick={() => setSelectedUser(null)}
                className="absolute top-4 right-4 bg-white/20 hover:bg-white/40 text-white h-8 w-8 rounded-full flex items-center justify-center font-bold text-lg transition-all"
              >
                ✕
              </button>
            </div>
            
            
{/* Scrollable Body */}
<div className="px-6 pb-6 relative flex-1">
              
              {/* Profile Image (Overlapping) */}
              <div className="flex justify-between items-end -mt-12 mb-4">
                <img 
                  src={selectedUser.image || profile} 
                  alt="user" 
                  className="h-24 w-24 rounded-full object-cover border-4 border-white shadow-md bg-white" 
                />
                <span className={`px-3 py-1 rounded-full text-[11px] font-black tracking-wider shadow-sm mb-2 ${selectedUser.isDisable === false ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                  {selectedUser.isDisable === false ? "● ACTIVE" : "● INACTIVE"}
                </span>
              </div>

              {/* User Name & Basic Info */}
              <div className="mb-6">
                <h3 className="text-2xl font-black text-gray-900 mb-1">{selectedUser.name || "Unknown User"}</h3>
                <p className="text-gray-500 font-medium text-sm flex items-center gap-2">
                  <span>📞 {selectedUser.phone || "-"}</span>
                  <span className="text-gray-300">|</span>
                  <span className="truncate" title={selectedUser.email}>✉️ {selectedUser.email || "-"}</span>
                </p>
              </div>

              {/* Address Details (Clean Card) */}
              <div className="bg-gray-50/80 rounded-xl p-4 mb-6 border border-gray-100">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Location & Joining</p>
                <div className="space-y-3 text-sm">
                  <div className="flex items-start gap-3">
                    <span className="text-lg">📍</span>
                    <p className="font-semibold text-gray-700 mt-0.5 leading-snug">
                      {[selectedUser.address, selectedUser.city, selectedUser.state, selectedUser.pincode].filter(Boolean).join(", ") || "No address provided"}
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-lg">📅</span>
                    <p className="font-semibold text-gray-700">
                      Joined: <span className="text-gray-900 font-black">{selectedUser.createdAt ? new Date(selectedUser.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' }) : "-"}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* Plan Details Section (Premium Dark Card) */}
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Current Subscription</p>
                {selectedUser.subscription ? (
                  <div className="bg-gradient-to-br from-[#131224] to-[#252345] rounded-2xl p-5 shadow-lg text-white relative overflow-hidden">
                    {/* Background Glow */}
                    <div className="absolute -top-10 -right-10 w-32 h-32 bg-white opacity-5 rounded-full blur-2xl"></div>
                    
                    <div className="flex justify-between items-start mb-5 relative z-10">
                      <div>
                        <h4 className="font-black text-2xl tracking-tight text-white mb-1">
                          {selectedUser.subscription.planId?.name || "Premium Plan"}
                        </h4>
                        <p className="text-blue-200 text-[10px] font-bold uppercase tracking-widest flex items-center gap-1">
                          ⏳ Expires: {new Date(selectedUser.subscription.endDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                        </p>
                      </div>
                      <div className="h-10 w-10 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm shadow-inner text-xl">
                        👑
                      </div>
                    </div>
                    
                    <div className="space-y-2 relative z-10">
                      {selectedUser.subscription.usageTracking && selectedUser.subscription.usageTracking.map((limit, i) => (
                        <div key={i} className="flex justify-between items-center bg-white/10 hover:bg-white/20 transition-colors p-2.5 rounded-xl border border-white/5 backdrop-blur-sm">
                          <span className="font-semibold text-sm text-gray-100 w-44 truncate" title={limit.pointName}>
                            {limit.pointName}
                          </span>
                          <div className="flex items-center gap-2">
                            <span className="text-[9px] uppercase text-gray-300 font-bold tracking-wider">Used</span>
                            <span className="font-black text-white text-xs bg-black/40 px-2.5 py-1 rounded-lg">
                              {limit.usedCount} <span className="text-gray-400">/ {limit.totalLimit}</span>
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="bg-gray-50 border-2 border-dashed border-gray-200 rounded-2xl p-6 text-center flex flex-col items-center justify-center">
                    <span className="text-3xl mb-2">🤷‍♂️</span>
                    <h4 className="text-gray-700 font-bold text-base mb-1">No Active Plan</h4>
                    <p className="text-gray-400 text-xs font-semibold">This user hasn't subscribed to any plan yet.</p>
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}